<template>
  <div :class="['search-tracker shadow rounded', { show }]"
    :style="selected_lv1 === null ? 'top: 118px' : 'top: 114px'">
    <div class="search-tracker-body border ">
      <div class="py-2 px-3 border-bottom">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center">
            <p class="d-inline-block search-label mr-2">
              {{ locale === 'KOR' ? '페이지 내 검색' : 'Search in Page' }}
            </p>

          </div>
          <span class="d-flex font-weight-300 px-2 mark-node rounded" style="font-size: 0.7rem;">
            {{ !searchedMarkedNode.length ? 0 : currentIndex + 1 }} / {{ !searchedMarkedNode.length ? 0 :
              totalSelection + 1 }}
          </span>
        </div>
        <b-input-group size="sm" class="mb-2">
          <b-form-input v-model="searchWord" class="search-tracker-input"
            :placeholder="locale === 'KOR' ? `검색어를 입력해주세요.` : `Please enter a keyword`"
            @keyup.enter.prevent="searchNewWord" />
          <b-input-group-append class="position-relative">
            <b-button variant="gray-border"
              class="d-flex justify-content-center align-items-center search-tracker-reset" @click="reset">
              <BIconX />
            </b-button>
            <b-button variant="gray-border" class="d-flex justify-content-center align-items-center"
              @click="searchNewWord">
              <BIconSearch />
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="py-2 px-3">
        <b-button-toolbar key-nav justify aria-label="Toolbar with button groups" class="page-search-toolbar">
          <b-button-group class="flex-grow-1">
            <b-button :disabled="!searchedMarkedNode.length || currentIndex === 0" size="sm" variant="skep"
              @click="goToPeer('start')">
              <BIconChevronDoubleUp />
            </b-button>
            <b-button :disabled="!searchedMarkedNode.length || currentIndex === 0" size="sm" variant="skep"
              @click="moveWord('backward')">
              <BIconChevronUp />
            </b-button>
            <b-button :disabled="!searchedMarkedNode.length || totalSelection === currentIndex" size="sm" variant="skep"
              @click="moveWord('forward')">
              <BIconChevronDown />
            </b-button>
            <b-button :disabled="!searchedMarkedNode.length || totalSelection === currentIndex" size="sm" variant="skep"
              @click="goToPeer('end')">
              <BIconChevronDoubleDown />
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </div>
    </div>
    <div class="search-tracker-navigation border border-top-0 p-1" @click="show = !show">
      <p :class="['navigation-label mr-2', locale]"> {{ locale === 'KOR' ? '페이지 내 검색' : 'Search in Page' }} </p>
      <svg class="navigation-icon" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" xml:space="preserve"
        shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality"
        fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 298 511.93">
        <path fill-rule="nonzero" fill="currentColor"
          d="M285.77 441c16.24 16.17 16.32 42.46.15 58.7-16.16 16.24-42.45 16.32-58.69.16l-215-214.47c-16.24-16.16-16.32-42.45-.15-58.69L227.23 12.08c16.24-16.17 42.53-16.09 58.69.15 16.17 16.24 16.09 42.54-.15 58.7l-185.5 185.04L285.77 441z" />
      </svg>
    </div>
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import { getParamsFromQueryString } from '@/components/util';

export default {
  name: 'SearchTracker',
  components: {
  },
  data() {
    return {
      show: false,
      searchWord: null,
      partialQuery: [],
      searchedMarkedNode: [],
      currentIndex: 0
    }
  },
  computed: {
    ...mapState('report_list', ['lang', 'view_mode']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapGetters('story_board', ['selected_lv1']),
    locale() {
      return this.lang
    },
    totalSelection() {
      return !this.searchedMarkedNode.length ? 0 : this.searchedMarkedNode.length - 1
    }
  },
  watch: {
    '$route.query.q_str'(current, before) {
      if (current) {
        this.show = true
      }

      if (current !== before) {
        this.reset()

        this.searchWord = !current ? null : current;
        this.partialQuery = this.generatePartialQuery();
        this.integrateQueryNodes()

        this.$nextTick(() => {
          this.sortSearchedMarkNode()
          this.moveToNode()
        });
      }
    },
  },
  methods: {
    reset() {
      document.getSelection().removeAllRanges();
      this.recoverMarkTag()
      this.partialQuery = []
      this.searchedMarkedNode = []
      this.currentIndex = 0
    },
    recoverMarkTag() {
      if (this.searchedMarkedNode.length) {
        this.searchedMarkedNode.forEach((_node) => {
          const parent = _node.node.parentNode;
          const textNode = document.createTextNode(_node.node.textContent);
          parent.replaceChild(textNode, _node.node);
        });
      }
    },
    searchNewWord() {
      if (!this.searchWord) {
        document.getSelection().removeAllRanges();
        this.recoverMarkTag()
        this.partialQuery = []
        this.searchedMarkedNode = []
        this.currentIndex = 0
        this.$router.push({ name: this.$route.name })

      } else if (this.searchWord) {
        this.reset()
        this.partialQuery = this.generatePartialQuery();
        this.integrateQueryNodes()
        this.$nextTick(() => {
          this.sortSearchedMarkNode()
          this.moveToNode()

        });
      }
    },
    goToPeer(direction) {
      if (direction === 'start') {
        this.currentIndex = 0
      } else {
        this.currentIndex = !this.searchedMarkedNode.length ? 0 : this.totalSelection
      }
      this.moveToNode()
    },
    moveWord(direction) {
      if (direction === 'forward' && this.currentIndex < this.totalSelection) {
        this.currentIndex++
      } else if (direction === 'backward' && this.currentIndex > 0) {
        this.currentIndex--
      }

      if (this.currentIndex <= this.totalSelection && this.currentIndex > -1) {
        this.moveToNode()
      }
    },
    moveToNode() {
      if (this.searchedMarkedNode.length > 0 && (this.currentIndex > -1 && this.currentIndex <= this.totalSelection)) {
        document.getSelection().removeAllRanges();

        const range = document.createRange();
        const selection = window.getSelection();
        const currentMovingDom = this.searchedMarkedNode[this.currentIndex].node;

        range.selectNode(currentMovingDom);
        selection.addRange(range);

        const _searchedDomTop = this.searchedMarkedNode[this.currentIndex].node.getBoundingClientRect().top + window.scrollY - 100;
        return window.scrollTo({ top: _searchedDomTop, behavior: 'smooth' })
      }
    },
    scrapQueryNode(word) {
      let _searchAreaXPath = null;
      if (this.selected_report.story_board) {
        _searchAreaXPath = `//*[@id="content"]/*[contains(.,'${word}')]`;
      } else {
        _searchAreaXPath = `//*[@id='standard-index-view']/*[contains(.,'${word}')]`;
      }

      const xpathResult = document.evaluate(_searchAreaXPath, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
      return xpathResult;
    },

    replaceTextOutsideCanvas(node, regex) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === 'canvas') {
        return;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        const matches = node.textContent.match(regex);
        if (matches) {
          const frag = document.createDocumentFragment();
          let lastIndex = 0;
          regex.lastIndex = 0;
          let match;
          while ((match = regex.exec(node.textContent)) !== null) {
            const textNode = document.createTextNode(node.textContent.substring(lastIndex, match.index));
            frag.appendChild(textNode);

            const mark = document.createElement('mark');
            mark.setAttribute('name', 'searched-word-highlight');
            const markId = `searched-word-highlight-${Date.now()}-${Math.random()}`;
            mark.setAttribute('id', markId);
            mark.textContent = match[0];

            // 필요한 경우 searchedMarkedNode에 추가
            this.searchedMarkedNode.push({
              text: match[0],
              markId: markId,
              node: mark,
              position: null
            });

            frag.appendChild(mark);
            lastIndex = regex.lastIndex;
          }
          const remainingText = node.textContent.substring(lastIndex);
          if (remainingText) {
            frag.appendChild(document.createTextNode(remainingText));
          }
          node.parentNode.replaceChild(frag, node);
        }
      } else {
        node.childNodes.forEach(child => {
          this.replaceTextOutsideCanvas(child, regex);
        });
      }
    },
    generateWholeQueryNodes() {
      const searchedMarkedNode = [];
      const _wholeWord = this.searchWord;
      const scrapedNodes = this.scrapQueryNode(_wholeWord);

      if (scrapedNodes.snapshotLength) {
        for (let index = 0; index < scrapedNodes.snapshotLength; index++) {
          const node = scrapedNodes.snapshotItem(index);
          const regex = new RegExp(_wholeWord, 'g');

          this.replaceTextOutsideCanvas(node, regex, (match, offset) => {
            const markId = `searched-word-highlight-${index}-${offset}`;
            searchedMarkedNode.push({
              text: match,
              markId: markId,
              node: null,
              position: null
            });
            return `<mark name="searched-word-highlight" id="${markId}">${match}</mark>`;
          });
        }
      }
      return searchedMarkedNode;
    },
    generatePartialQuery() {
      if (!this.searchWord) {
        return []
      } else {
        const partialQuery = this.searchWord.trim().split(' ').sort()
        const trimmedWord = this.searchWord.replace(/\s/g, '')
        if (!partialQuery.includes(trimmedWord)) {
          partialQuery.unshift(trimmedWord)
        }

        if (partialQuery.includes(this.$route.query.q_str)) {
          const qStrIndex = partialQuery.findIndex(_partial => _partial.trim() === this.searchWord.trim())
          if (qStrIndex > -1) {
            partialQuery.splice(qStrIndex)
          }
        }
        return partialQuery.map((_partial) => ({ keyword: _partial, searchable: true }))
      }
    },
    generatePartialQueryNodes(partialQuery) {
      const wholeQueryWord = this.searchWord;
      const searchedMarkedNode = [];

      partialQuery.forEach((_query, _pQ) => {
        const partialQueryNodes = this.scrapQueryNode(_query);

        if (partialQueryNodes.snapshotLength) {
          for (let index = 0; index < partialQueryNodes.snapshotLength; index++) {
            const node = partialQueryNodes.snapshotItem(index);
            if (!node.innerHTML.includes(wholeQueryWord) && node.tagName !== 'MARK') {
              const regex = new RegExp(_query, 'g');

              this.replaceTextOutsideCanvas(node, regex, (match, offset) => {
                const markId = `searched-word-highlight-${_pQ}-${index}-${offset}`;
                searchedMarkedNode.push({
                  text: match,
                  markId: markId,
                  node: null,
                  position: null
                });
                return `<mark name="searched-word-highlight" id="${markId}">${match}</mark>`;
              });
            }
          }
        }
      });
      return searchedMarkedNode;
    },
    integrateQueryNodes() {
      let queryNodes = this.generateWholeQueryNodes()
      let searchablePartial = this.partialQuery.filter(({ searchable }) => searchable === true)

      if (searchablePartial.length) {
        searchablePartial = searchablePartial.map(({ keyword }) => keyword)
        const _partialQueryNodes = this.generatePartialQueryNodes(searchablePartial)
        queryNodes = [...queryNodes, ..._partialQueryNodes]
      }

      if (queryNodes.length) {
        queryNodes = queryNodes.map((_markedNode) => ({
          ..._markedNode,
          node: document.getElementById(_markedNode.markId)
        }))
        this.searchedMarkedNode = queryNodes
      }

    },
    sortSearchedMarkNode() {
      if (this.searchedMarkedNode) {
        this.searchedMarkedNode = this.searchedMarkedNode.map((_markedNode) => ({
          ..._markedNode,
          position: document.getElementById(_markedNode.markId).getBoundingClientRect()
        }))

        this.searchedMarkedNode = this.searchedMarkedNode
          .sort((a, b) => a.position.left - b.position.left)
          .sort((a, b) => a.position.top - b.position.top)
      }
    }
  },
  created() {
    this.searchWord = !this.$route.query.q_str ? null : this.searchWord;
    this.partialQuery = this.generatePartialQuery();
  },
  mounted() {
    
    document.getSelection().removeAllRanges();
    this.integrateQueryNodes()
    
    this.$nextTick(() => {
      this.sortSearchedMarkNode()
      this.moveToNode()
    });

    if (this.$route.query.q_str) {
      this.show = true
      this.reset()

      this.searchWord = this.$route.query.q_str;
      setTimeout(() => {
      this.partialQuery = this.generatePartialQuery();
      this.integrateQueryNodes()

        this.sortSearchedMarkNode()
        this.moveToNode()
      }, 1000);
    }
  }
}
</script>

<style lang="scss">
.search-tracker {
  position: fixed;
  right: 0rem;
  width: 250px;
  display: flex;
  flex-direction: column;
  z-index: 1;
  transform: translateY(-164px);
  transition: transform 700ms ease-in-out 300ms;

  &-body {
    background-color: #ffffff;
  }

  &.show {
    transform: translateY(-1rem);

    .search-tracker-navigation {
      .navigation-label {
        transition: opacity 200ms ease-in-out,
          height 200ms ease-in-out 300ms,
          width 200ms ease-in-out 300ms;
        width: 0px;
        height: 0px;
        opacity: 0;
      }

      .navigation-icon {
        transform: rotate(90deg);
      }
    }
  }

  &-navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909090;
    background-color: #f8f9fa;
    font-size: 0.9rem;
    cursor: pointer;

    &:hover {
      color: #4E4E4E;
    }

    .navigation-label {
      transition: width 300ms ease-in-out 500ms,
        height 300ms ease-in-out 500ms,
        opacity 300ms ease-in-out 1200ms;
      margin-bottom: 0px;
      font-weight: 500;
      height: 28px;
      opacity: 1;
      text-align: center;

      &.en {
        width: 120px;
      }

      &:not(.en) {
        width: 150px;
      }
    }

    .navigation-icon {
      transform: rotate(-90deg);
    }
  }

  .search-label {
    margin-bottom: 0px;
    font-size: 0.9rem;
  }

  .search-partial-checkbox-btn {
    .btn {
      font-size: 0.7rem;
      padding: 0.1rem 0.7rem;
      border-radius: 1rem;
    }
  }


  .search-tracker-reset {
    &:focus {
      box-shadow: none;
      outline: none;
    }
  }

  .page-search-toolbar {
    .btn {
      font-size: 0.7rem;
    }
  }

  @media print {
    display: none !important;
  }
}

.mark-node {
  background-color: transparent;
  border: 1px solid black;
}

mark[name="searched-word-highlight"] {
  background-color: yellow;
  color: black;
}
</style>
